module.exports = __webpack_public_path__ + "img/intro_title_3.ef5550a3.png";